import { createAction } from "redux-actions";
import { SET_MEMBERS_DAY_SALE_EVENT } from "../constants";

const setMembersDaySaleEvent = createAction(
  SET_MEMBERS_DAY_SALE_EVENT,
  membersDaySaleEvent => membersDaySaleEvent
);

export default setMembersDaySaleEvent;
